// extracted by mini-css-extract-plugin
var _1 = "ImageCarousel-module__animateUploadProgressBarWidth--elgsN";
var _2 = "ImageCarousel-module__animatedBackground--g_7fY";
var _3 = "ImageCarousel-module__container--LAvFg";
var _4 = "ImageCarousel-module__content--Q_7cB";
var _5 = "ImageCarousel-module__controlsContainer--oiWSF";
var _6 = "ImageCarousel-module__isSingleMode--FUG1A";
var _7 = "ImageCarousel-module__thumbnailBar--WOzrI";
var _8 = "ImageCarousel-module__thumbnailBarBackground--u1f_V";
var _9 = "ImageCarousel-module__thumbnailBarHidden--dnQ1h";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "container", _4 as "content", _5 as "controlsContainer", _6 as "isSingleMode", _7 as "thumbnailBar", _8 as "thumbnailBarBackground", _9 as "thumbnailBarHidden" }
